export const actionTypes = {
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
  TOGGLE_DELETE_MODAL: 'TOGGLE_DELETE_MODAL',
  SET_DRAWER_TITLE: 'SET_DRAWER_TITLE',
  SET_ROLE: 'SET_ROLE',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_IS_LOADING_ROLE: 'SET_IS_LOADING_ROLE',
  SET_ROLE_LIST: 'SET_ROLE_LIST',
  OPTIMISTICALLY_UPDATE_ROLE_LIST: 'OPTIMISTICALLY_UPDATE_ROLE_LIST',
  OPTIMISTICALLY_DELETE_ROLE: 'OPTIMISTICALLY_DELETE_ROLE',
  SET_TABS_MACROS: 'SET_TABS_MACROS',
  SET_INITIAL_PERMISSIONS: 'SET_INITIAL_PERMISSIONS',
  SET_EDIT_PERMISSIONS: 'SET_EDIT_PERMISSIONS',
  UPDATE_EDIT_PERMISSIONS: 'UPDATE_EDIT_PERMISSIONS',
  SET_CUSTOM_PERMISSIONS: 'SET_CUSTOM_PERMISSIONS',
  SET_ROLE_REQUEST_BODY: 'SET_ROLE_REQUEST_BODY',
  UPDATE_ROLE_REQUEST_BODY: 'UPDATE_ROLE_REQUEST_BODY',
  UPDATE_ROLE_REQUEST_BODY_NAME: 'UPDATE_ROLE_REQUEST_BODY_NAME',
  SET_ROLE_NAME_ERROR: 'SET_ROLE_NAME_ERROR',
};
